import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { store } from './redux/_helpers';
import firebase from 'firebase/compat/app';
import 'trans/i18n';


var firebaseConfig = {
  apiKey: "AIzaSyA1Af11Li1Iu6SIf0b_YI07ZCU12JU7CQA",
  authDomain: "invoicedelivery-c1ce8.firebaseapp.com",
  databaseURL: "https://invoicedelivery-c1ce8-default-rtdb.firebaseio.com/",
  projectId: "invoicedelivery-c1ce8",
  storageBucket: "invoicedelivery-c1ce8.appspot.com",
};

firebase.initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
